function NewRole() {
    return {
        id: null,       
        name: "New role",
		isSysAdmin : 0,
		permissions: []
      }
}
export default NewRole;